import { Modal, Form, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { createTrainingGroup } from "store/slices/groupsSlice";
import { closeModal } from "store/slices/modalsSlice";
import dayjs from "dayjs";
import TrainingGroupForm from "./training-group-form";
import { useEffect } from "react";
import { getTrainings } from "store/slices/trainingsSlice";

const NewTrainingGroupModal = () => {
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // Récupérer les données du modal et de la formation
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { loading } = useSelector((state) => state?.groups);

  // Vérifier si c'est notre modal qui est ouvert
  const open = isModalOpen && modalType === "new_training_group";

  // Récupérer les IDs depuis les props du modal
  const { schoolId, formationId } = modalProps || {};

  useEffect(() => {
    console?.log("Modal props:", modalProps);

    // 0) fetch trainings
    dispatch(
      getTrainings({
        page: 1,
        all:true
      })
    );
  }, [dispatch]);
  const onSubmit = async (values) => {
    try {
      const formattedValues = {
        ...values,
        schoolId,
        formationId,
        startingDate: dayjs(values?.startingDate)?.toISOString(),
        // Les champs sont déjà formatés par le formulaire
      };

      await dispatch(createTrainingGroup(formattedValues))?.unwrap();

      notification?.success({
        message: t("groups.crud.form.success"),
        duration: 3,
      });

      onClose();
    } catch (error) {
      notification?.error({
        message: t("groups.crud.form.error.failed"),
        description: error?.message || t("common.error.generic"),
        duration: 4,
      });
    }
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title={t("groups.crud.new")}
      open={open}
      onCancel={onClose}
      onOk={() => form?.submit()}
      confirmLoading={loading}
      destroyOnClose
      width={800}
      centered
      maskClosable={false}
    >
      <TrainingGroupForm
        form={form}
        onSubmit={onSubmit}
        schoolId={schoolId}
        formationId={formationId}
      />
    </Modal>
  );
};

export default NewTrainingGroupModal;
